import {Component, input, ChangeDetectionStrategy} from '@angular/core';
import {CardComponent} from '../card/card/card.component';
import {CardBodyComponent} from '../card/card-body/card-body.component';
import {CardHeaderComponent} from '../card/card-header/card-header.component';

/**
 * Скелетон для страниц-карточек: крупная карточка с заголовком
 * и дочерними блоками — повторяет форму реального контента.
 * variant:
 *  - 'bars'  — дочерние блоки как вложенные карточки-строки (разделы)
 *  - 'tiles' — flex-грид тайлов (секционные блоки главной)
 */
@Component({
    selector: 'app-cards-skeleton',
    templateUrl: './cards-skeleton.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CardComponent, CardBodyComponent, CardHeaderComponent]
})
export class CardsSkeletonComponent {
  count = input<number>(3);
  /** сколько дочерних блоков рисовать внутри каждой карточки */
  children = input<number>(3);
  variant = input<'bars' | 'tiles'>('bars');

  get items(): number[] {
    return Array.from({length: Math.max(0, this.count())});
  }

  get childItems(): number[] {
    return Array.from({length: Math.max(0, this.children())});
  }
}
